<template>
    <div>
        <InputField type="text" name="url" :label="this.$t('url')" v-model="content.url" @error="fieldError"
            :rules="{required: true, length: {min: 2, max: 128}}"
            :helpTip="{id: 'event.operation.mustache', text: this.$t('usePlaceholders'), type: 'tooltip'}"
        />

        <CodeEditor
            v-model="content.headers"
            :label="this.$t('headers')"
            :label-cols="2"
            :horizontal="true"
            :controls='[""]'
            placeholder="{}"
            @onInput="onInputHeaders"
            :errors="editorHeaderErrors"
            :withButton="false"
        />

        <CodeEditor
            v-model="content.postData"
            :label="this.$t('jsonBody')"
            :label-cols="2"
            :horizontal="true"
            :controls='[""]'
            :placeholder="this.$t('leftBlank')"
            @onInput="onInputPost"
            :errors="editorPostErrors"
            :withButton="false"
        />
    </div>
</template>

<script>
import InputField from '@/components/form/Input'
import CodeEditor from '@/components/form/Editor/Code'
import debounce from 'lodash/debounce'

export default {
    components: {
        InputField,
        CodeEditor
    },
    props: {
       value: {
         type: Object
       }
    },
    computed: {
        content: {
            get() {
                return this.value || {};
            },

            set(val) {
                this.$emit('input', val);
            }
        }
    },
    methods: {
        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors() {
            return this.errors.find((i, e) => {
                return i.error
            })
        },

        save() {
            this.modal.show = false
        },

        onInputHeaders: debounce(function(code) {
            if (code === "") return;

            try {
                this.editorHeaderErrors = [];
                JSON.parse(code);
            } catch(e) {
                this.editorHeaderErrors.push(e)
            }

        }, 1000),

        onInputPost: debounce(function(code) {
            if (code === "") return;

            try {
                this.editorPostErrors = [];
                JSON.parse(code);
            } catch(e) {
                this.editorPostErrors.push(e)
            }

        }, 1000)
    },
    data: function() {
        return {
            errors: [],
            editorHeaderErrors: [],
            editorPostErrors: [],
            modal: {
                show: false
            }
        }
    },

    mounted() { }
}
</script>
